export const BATTERY_COMPONENT_NAME = 'BatteryStatus';
export const BILGE_PUMP_COMPONENT_NAME = 'BilgePump';
export const CHART_COMPONENT_NAME = 'Chart';
export const EMPTY_WIDGET_COMPONENT_NAME = 'EmptyWidget';
export const EVENT_COMPONENT_NAME = 'EventComponent';
export const FUEL_USAGE_COMPONENT_NAME = 'FuelUsage';
export const GLOBAL_BILGE_PUMP_COMPONENT_NAME = 'GlobalBilgePump';
export const GLOBAL_GENERATOR_COMPONENT_NAME = 'GlobalGenerator';
export const PEN_COMPONENT_NAME = 'Pen';
export const SENSOR_WIDGET_COMPONENT_NAME = 'SensorWidget';
export const TANK_COMPONENT_NAME = 'Tank';
export const SILO_COMPONENT_NAME = 'Silo';
export const CAMERA_STREAM_WIDGET = 'CameraStreamWidget';
export const BIOMASS_COMPONENT_NAME = 'BiomassWidget';
export const BIOMASS_DISTRIBUTION_COMPONENT_NAME = 'BiomassDistribution';
export const LICE_COUNT_COMPONENT_NAME = 'LiceCount';
export const PEN_WIDGET_COMPONENT_NAME = 'PenWidget';
export const FEEDING_WIDGET_COMPONENT_NAME = 'FeedingWidget';
export const WELFARE_SUMMARY_WIDGET_COMPONENT_NAME = 'WelfareSummaryWidget';
export const WELFARE_INDICATOR_WIDGET_COMPONENT_NAME = 'WelfareIndicatorWidget';
export const ORBITONE_HEATMAP_WIDGET_COMPONENT_NAME = 'OrbitoneHeatmapWidget';
export const ORBITONE_TABLE_WIDGET_COMPONENT_NAME = 'OrbitoneTableWidget';
